import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {RoleViewModel} from "../../models/role-view-model";
import {ParticipantRoleAndPermissionsViewModel} from "../../models/participant-role-and-permissions-view-model";
import {ClaimSelect2ViewModel} from "../../models/claim-view-model";
import {PermissionEnum, PermissionEnumMapping} from "../../services/guards/permissions";
import {IdentityResultViewModel} from "../../models/register-result-view-model";
import {Select2OptionData} from "ng-select2";
import {UserDataStoreService} from '../../services/user-data-store.service';
import {ToastrService} from 'ngx-toastr';
import {Subject, Subscription} from "rxjs";
import {UserManagementService} from "../../services/user-management.service";
import {UserViewModel} from "../../models/user-view-model";
import {ConfirmationDialogComponent} from "../../partials/confirmation-dialog/confirmation-dialog.component";
import {AuthenticationService} from "../../services/authentication.service";

@Component({
  selector: 'app-role-view',
  templateUrl: './role-view.component.html',
  styleUrls: ['./role-view.component.scss']
})
export class RoleViewComponent implements OnInit {

  public roleAndPermissionsViewModel: ParticipantRoleAndPermissionsViewModel;

  public allClaims: any[] = [];

  public selectedClaims: string[] = [];
  public canEdit: boolean;
  public canDelete: boolean;
  public canAdd: boolean;

  public select2options: any = {
    multiple: true,
    width: '100%'
  };

  public identityResult: IdentityResultViewModel;

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<boolean>;
  private subscription: Subscription;
  public usersByRole: UserViewModel[] = [];

  constructor(private _modal: NgbActiveModal,
              private _authenticationService: AuthenticationService,
              private _userManagementService: UserManagementService,
              private modalService: NgbModal,
              private _userDataStore: UserDataStoreService,
              private _toastService: ToastrService) {
    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditRole], []);
    this.canDelete = this._userDataStore.hasRequiredPermissions([PermissionEnum.DeleteRole], []);
    this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddRole], []);
  }

  public async ngOnInit(): Promise<void> {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };

    if(this.roleAndPermissionsViewModel && this.roleAndPermissionsViewModel.role && this.roleAndPermissionsViewModel.role.id){
      this.usersByRole = await this._userManagementService.GetUsersByRole(this.roleAndPermissionsViewModel.role.id);
      this.canAdd = false;
    }
    else{
      this.canEdit = false;
    }
    this.allClaims = [];
    let i = 0;
    for (const permission in PermissionEnum) {
      this.allClaims.push({
        id: (++i).toString(),
        claimType: "AccessPermission",
        claimValue: PermissionEnum[permission].toString(),
        text: PermissionEnumMapping[PermissionEnum[permission]]
      });
    }

    if (!this.roleAndPermissionsViewModel) {
      this.roleAndPermissionsViewModel = {
        role: {
          name: "",
          description: "",
        },
        claims: []
      };
    } else {
      for (const claim of this.roleAndPermissionsViewModel.claims) {
        claim.id = this.allClaims.find(x => x.claimValue == claim.claimValue).id;
        this.selectedClaims.push(claim.id.toString());
      }
    }
  }

  public async initTable(selectedIndex: number): Promise<void> {
    if (selectedIndex == 2) {
      this.dtTrigger = new Subject();
      this.dtTrigger.next();
    }
  }


  public async save(): Promise<void> {
    if (!this.canEdit && !this.canAdd) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this.roleAndPermissionsViewModel.claims = [];
      for (const claim of this.selectedClaims) {
        this.roleAndPermissionsViewModel.claims.push(this.allClaims.find(x => x.id == claim));
      }

      const result = await this._authenticationService.InsertOrUpdateRoleWithPermissions(this.roleAndPermissionsViewModel);
      if (!result.identityResult.succeeded) {
        this.identityResult = result.identityResult;
      } else {
        if(this.roleAndPermissionsViewModel && this.roleAndPermissionsViewModel.role && this.roleAndPermissionsViewModel.role.id){
        this._toastService.success("Role updated.", "Success");
        this._modal.close();
        }
        else{
          this._toastService.success("Role added.", "Success");
        this._modal.close();
        }

      }
    }
  }

  public async delete(): Promise<void> {
    if (this.usersByRole.length > 0) {
      this._toastService.error("You can not delete a role that has been assigned to users, please first unassign the role from all users", "Error");
    } else {
      const modalRef = this.modalService.open(ConfirmationDialogComponent, {
        windowClass: 'modal-fade-in',
        centered: false,
        size: 'xl',
        backdrop: 'static'
      });
      modalRef.componentInstance.showCancel = true;
      modalRef.componentInstance.title = 'Delete Role';
      modalRef.componentInstance.message = '<p>Are you sure you want to delete this role from the system?</p>';
      modalRef.componentInstance.acceptButtonText = 'Yes';
      modalRef.componentInstance.cancelButtonText = 'No';

      const modalResult: boolean = await modalRef.result;
      if (modalResult) {
        const result = await this._authenticationService.DeleteRole(this.roleAndPermissionsViewModel);
        if (result.succeeded) {
          this._toastService.success("Role has been successfully removed.", "Success");
          this._modal.close();
        } else {
          this._toastService.error("Delete of Role failed.", "Error");
        }
      }
    }
  }

  public close() {
    this._modal.close();
  }

  public ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    if (this.dtTrigger) {
      this.dtTrigger.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
